import { formatCurrency, formatDate } from '@crm/shared';
import { CalendarClock, CheckCircle2 } from 'lucide-react';
import { StatusHeader, SummaryRow } from '@/components';
import type { PhoneLine } from '../api';

export function LineSummary({ linha }: { linha: PhoneLine }) {
  const cobranca = linha.openCharge;

  return (
    <div className="space-y-4">
      {cobranca ? (
        <StatusHeader
          icon={<CalendarClock className="h-5 w-5" />}
          title="Plano mensal da linha"
          detail="Cobranca mensal antecipada."
        />
      ) : (
        <StatusHeader
          icon={<CheckCircle2 className="h-5 w-5" />}
          tone="ok"
          title="Mensalidade em dia"
          detail={
            linha.paidThrough
              ? `A linha esta paga ate ${formatDate(linha.paidThrough)}.`
              : 'A linha esta paga.'
          }
        />
      )}

      <div className="space-y-2 border-t border-border pt-4">
        <SummaryRow label="Numero" value={linha.phoneNumber} />
        <SummaryRow label="Mensalidade" value={formatCurrency(linha.monthlyPrice)} />
        {cobranca ? (
          <SummaryRow
            label="Periodo"
            value={`${formatDate(cobranca.periodStart)} a ${formatDate(cobranca.periodEnd)}`}
          />
        ) : linha.paidThrough ? (
          <SummaryRow label="Proxima cobranca" value={formatDate(linha.paidThrough)} />
        ) : null}
      </div>
    </div>
  );
}
